export default __webpack_public_path__ + "static/media/intro-world-map.6cac6c9a.png";